export class Country
{
    public id: number; 
    public name: string;
    public abbreviation: string;
}